<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="nome"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">PLANOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoPlano = true" tile color="#3BA8A2">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="#94AAB4" @click="carregaDados">Recarregar</v-btn>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <p style="margin: 0px">
              <v-icon :color="item.ativo ? 'success' : 'error'">mdi-circle</v-icon>
            </p>
          </template>
          <template v-slot:[`item.valorMensalidade`]="{ item }">
            R$ {{ item.valorMensalidade }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoPlano" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 0px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Nome do Plano*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field 
                label="Quantidade de Alunos*" 
                type="number" 
                outlined 
                dense 
                hide-details 
                v-model.number="editedItem.qtdAlunos"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field 
                label="Professores Simultâneos*" 
                type="number" 
                outlined 
                dense 
                hide-details 
                v-model.number="editedItem.qtdProfSimultaneos"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field 
                label="Valor Mensalidade*" 
                outlined 
                dense 
                hide-details 
                v-model="editedItem.valorMensalidade"
                prefix="R$"
                @input="formatarValor"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" class="d-flex align-center">
              <v-switch 
                inset 
                v-model="editedItem.ativo" 
                label="Plano Ativo"
                color="#3BA8A2"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoPlano = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarPlano">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Qtd. Alunos', value: 'qtdAlunos' },
          { text: 'Prof. Simultâneos', value: 'qtdProfSimultaneos' },
          { text: 'Valor Mensalidade', value: 'valorMensalidade' },
          { text: 'Status', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
      },
      dialogoPlano: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        qtdAlunos: 0,
        qtdProfSimultaneos: 0,
        valorMensalidade: '',
        ativo: false,
      },
      defaultItem: {
        nome: '',
        qtdAlunos: 0,
        qtdProfSimultaneos: 0,
        valorMensalidade: '',
        ativo: false,
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo plano' : 'Editar plano'
      },
    }),

    watch: {
      dialogoPlano(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      }
    },

    mounted() {
      this.carregaDados()
    },

    methods: {
      async carregaDados () {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Planos?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          }
        })
        .catch(() => {
          this.isLoading = false
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoPlano = true
        this.isLoading = false
      },

      formatarValor() {
        // Remove caracteres não numéricos exceto vírgula e ponto
        let valor = this.editedItem.valorMensalidade.replace(/[^\d.,]/g, '');
        this.editedItem.valorMensalidade = valor;
      },

      async salvarPlano() {
        var vm = this;
        if (this.editedItem.nome && this.editedItem.qtdAlunos && this.editedItem.qtdProfSimultaneos && this.editedItem.valorMensalidade) {
          this.isLoading = true
          await axios.post(baseApiUrl + 'Planos/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoPlano = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaDados()
            }           	
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("F9A825", "Preencha todos os campos obrigatórios para prosseguir", "ATENÇÃO")
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o plano ' + item.nome + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Planos/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {    
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaDados()
          })
          .catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao excluir plano", "DESCULPE")
          })
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>